import React from 'react';

import { Box, Stack } from '@mantine/core';
import WorkoutDetail from 'components/Workout/WorkoutDetail';

import type { WorkoutTemplatePreviewData } from './types';

interface PreviewModalContentProps {
  template: WorkoutTemplatePreviewData;
  showCoachNotes?: boolean;
}

const PreviewModalContent = ({ template, showCoachNotes }: PreviewModalContentProps): JSX.Element => (
  <Stack spacing={0} sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
    <Box
      sx={{
        flex: 1,
        overflowY: 'auto',
        padding: '1.5rem',
      }}
    >
      <WorkoutDetail template={template} showCoachNotes={showCoachNotes} />
    </Box>
  </Stack>
);

export default PreviewModalContent;
